import { Button } from '@ccg/core';
import React$1, { useContext } from 'react';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Link$1 from '../../basics/Link/Link.js';
import Logo$1 from '../../basics/Logo/Logo.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import StyledNavigation from './Navigation.style.js';
import { NavigationContext } from '../../contexts/NavigationProvider/NavigationProvider.js';

const Navigation = ({
  className,
  menuLabel,
  backLabel,
  homeLink,
  mainLinks,
  secondaryLinks
}) => {
  const {
    isOpen,
    toggleNavigation,
    listRef
  } = useContext(NavigationContext);
  const languageLink = mainLinks[mainLinks.length - 1];
  return /*#__PURE__*/React$1.createElement(StyledNavigation, {
    className: className,
    isOpen: isOpen
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "navigation__wrapper"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "navigation__inner"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "navigation__header"
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({}, homeLink, {
    "aria-label": "Home",
    noHover: true,
    className: "navigation__logo"
  }), /*#__PURE__*/React$1.createElement(Logo$1, {
    inline: true,
    transition: {
      property: 'all'
    }
  })), /*#__PURE__*/React$1.createElement(Button, {
    className: "navigation__toggle",
    onClick: toggleNavigation
  }, /*#__PURE__*/React$1.createElement("span", {
    className: "navigation__toggle-icon"
  }), /*#__PURE__*/React$1.createElement(Typography$1, {
    as: "span",
    variant: "subline",
    transform: "uppercase"
  }, isOpen ? backLabel : menuLabel)), languageLink && /*#__PURE__*/React$1.createElement(Link$1, _extends({}, languageLink, {
    variant: "subline",
    noHover: true,
    className: "navigation__lang"
  }), /*#__PURE__*/React$1.createElement("span", null, languageLink.label))), /*#__PURE__*/React$1.createElement("div", {
    className: "navigation__list",
    ref: listRef
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "navigation__list-inner"
  }, /*#__PURE__*/React$1.createElement("ol", {
    className: "navigation__mainlist"
  }, mainLinks.map((link, i) => i !== mainLinks.length - 1 && link && link.label && /*#__PURE__*/React$1.createElement("li", {
    key: link.label,
    "data-primary-label": link.label.replace(/\s/g, '')
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({}, link, {
    variant: "hero",
    noHover: true
  }), /*#__PURE__*/React$1.createElement("span", null, link.label))))), /*#__PURE__*/React$1.createElement("ul", {
    className: "navigation__secondarylist"
  }, secondaryLinks.map(link => link && link.label && /*#__PURE__*/React$1.createElement("li", {
    key: link.label,
    "data-primary-label": link.label.replace(/\s/g, '')
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({}, link, {
    variant: "subline",
    noHover: true
  }), /*#__PURE__*/React$1.createElement("span", null, link.label))))))))));
};

Navigation.propTypes = {
  className: PropTypes$1.string,
  menuLabel: PropTypes$1.string.isRequired,
  backLabel: PropTypes$1.string.isRequired,
  homeLink: PropTypes$1.shape().isRequired,
  mainLinks: PropTypes$1.arrayOf(PropTypes$1.shape()).isRequired,
  secondaryLinks: PropTypes$1.arrayOf(PropTypes$1.shape()).isRequired
};
Navigation.defaultProps = {
  className: ''
};

export default Navigation;
